import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import { KycCountries } from './types/Kyc';

export type GetKycCountries = (
  userId: 'me' | number,
) => Promise<{ data: KycCountries }>;

export default (makeCall: MakeCall): GetKycCountries =>
  (userId = 'me') =>
    makeCall<KycCountries>('GET', `${APIV2_URL}/user/${userId}/kyc-countries`);
